import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getProcedureRunUIString, StringCase} from 'procedures/ProceduresStringKeys';

/**
 * Extract the procedure-related id (stdy_… or prp_…) from a procedure run plan
 * tool call's args, or null if the tool is not procedure-aware or the id is absent.
 */
export function getProcedureToolId(toolName: string, args?: Record<string, unknown>): string | null {
  if (args == null) {
    return null;
  }
  let value: unknown;
  switch (toolName) {
    case 'CreateProcedureRunPlan':
      value = args.study_id;
      break;
    case 'PromoteProcedureRunPlan':
    case 'UpdateProcedureRunPlanConditions':
      value = args.procedure_run_plan_id;
      break;
    default:
      return null;
  }
  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }
  return value;
}

export function getProcedureRunPlanLabel(
  toolName: string,
  isCompleted: boolean,
  procedureType: ProcedureType
): string {
  const runWord = getProcedureRunUIString(procedureType, {stringCase: StringCase.LOWER});
  switch (toolName) {
    case 'CreateProcedureRunPlan':
      return isCompleted ? `Created ${runWord} plan` : `Creating ${runWord} plan`;
    case 'PromoteProcedureRunPlan':
      return isCompleted ? `Created ${runWord}` : `Creating ${runWord}`;
    case 'UpdateProcedureRunPlanConditions':
      return isCompleted ? `Updated ${runWord} plan conditions` : `Updating ${runWord} plan conditions`;
    default:
      return '';
  }
}
